// extracted by mini-css-extract-plugin
module.exports = {"main":"DreamPostView_main_1wGDl","caption":"DreamPostView_caption_2C66j"};